import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CSSTransitionReplace from 'react-css-transition-replace';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import TextField from '../TextField';
import Modal from '../Modal';

const OTHER_REASON_VALUE = 'other';

const propTypes = {
  onConfirm: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  reasonList: PropTypes.array.isRequired,
  confirmBtnText: PropTypes.string.isRequired,
  handleRef: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

class CancelReasonsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reason: null,
      error: null,
      otherReasonText: '',
    };
  }

  onReasonChange = (event, reason) => this.setState({ reason });

  onOtherTextChange = otherReasonText => this.setState({ otherReasonText });

  onConfirmClick = () => {
    const { reason, otherReasonText } = this.state;
    const {
      onConfirm,
      intl: { formatMessage },
    } = this.props;

    if (reason) {
      if (reason === OTHER_REASON_VALUE) {
        if (otherReasonText.length > 0) {
          onConfirm(reason, otherReasonText);
        } else {
          this.setState({
            error: formatMessage({
              id: 'dealer_cancel_modal.missing_other_reason_text_error',
              defaultMessage: 'Please type the reason in the above field',
            }),
          });
        }
      } else {
        onConfirm(reason);
      }
    } else {
      this.setState({
        error: formatMessage({
          id: 'dealer_cancel_modal.missing_reason_error',
          defaultMessage: 'Please choose a reason',
        }),
      });
    }
  };

  renderReasons = () => {
    const { reasonList, isLoading } = this.props;
    const listIntoReasonRadios = reason => {
      return (
        <RadioButton
          key={reason.value}
          value={reason.value}
          label={reason.label}
          disabled={isLoading}
          className="ActionButtons__reason"
        />
      );
    };

    return reasonList.map(listIntoReasonRadios);
  };

  render() {
    const {
      isLoading,
      intl: { formatMessage },
      confirmBtnText,
    } = this.props;
    const { error, otherReasonText, reason } = this.state;

    return (
      <Modal
        ref={this.props.handleRef('modal')}
        hideOnConfirm={false}
        onConfirm={this.onConfirmClick}
        disableConfirmBtn={isLoading}
        isLoading={isLoading}
        title={formatMessage({
          id: 'logout_confirm_title',
          defaultMessage: 'Please confirm',
        })}
        cancelButtonText={formatMessage({
          id: 'orderdetails_step_finalisation_decline_cancel',
          defaultMessage: 'Cancel',
        })}
        confirmButtonText={confirmBtnText}
      >
        <div className="ActionButtons__cancel_reasons">
          <div>
            <FormattedMessage
              id="dealer_cancel_modal.decline_reason_text"
              defaultMessage="To decline this order please choose a reason below:"
            />
          </div>
          <RadioButtonGroup
            valueSelected={reason}
            onChange={this.onReasonChange}
            className="ActionButtons__reason_radios_wrapper"
            name="dealerCancelReason"
          >
            {this.renderReasons()}
            <RadioButton
              value={OTHER_REASON_VALUE}
              label="Outra"
              className="ActionButtons__reason"
              disabled={isLoading}
            />
          </RadioButtonGroup>
          <CSSTransitionReplace
            transitionName="CSSTG-fade"
            transitionEnterTimeout={375}
            transitionLeaveTimeout={300}
          >
            {reason === OTHER_REASON_VALUE && (
              <div key="text-field-wrapper" className="ActionButtons__text_field_wrapper">
                <TextField
                  name="other-reason-text-field"
                  value={otherReasonText}
                  onChange={this.onOtherTextChange}
                  placeholder={formatMessage({
                    id: 'dealer_cancel_modal.decline_other_reason_text_field_hint',
                    defaultMessage: 'Insert the reason here',
                  })}
                />
              </div>
            )}
          </CSSTransitionReplace>
          <CSSTransitionReplace
            transitionName="CSSTG-fade"
            transitionEnterTimeout={375}
            transitionLeaveTimeout={300}
          >
            {error && (
              <div key="error-msg" className="ActionButtons__error">
                {error}
              </div>
            )}
          </CSSTransitionReplace>
        </div>
      </Modal>
    );
  }
}

CancelReasonsModal.propTypes = propTypes;

export default CancelReasonsModal;



// WEBPACK FOOTER //
// ../ui-components/components/ActionButtons/CancelReasonsModal.jsx